import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import axios from 'axios';
import useTable from "../../../../components/useTable";
import { Dimmer } from '../../../spinner';
import { Mensaje, MensajeSiNo } from '../../../../components/mensajes2';

//UI
import {
  DangerButton,
  SuccessButton,
} from "../../../../ui/buttons/Button";
import { Input } from "../../../../ui/inputs/Input";
import CatalogoConceptosNomina from "../../../../catalogos/catalogoConceptosNomina";

const headCells = [
  {
    id: "codconcep",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Cod. Concepto",
    textAlign: "center",
  },
  {
    id: "nomconcep",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Nombre Concepto",
    textAlign: "center",
  },
];

export default function GruposNominas({ show, setShow, setTabla, operacion, id }) {
  const [codGrupo, setCodGrupo] = useState('');
  const [nombre, setNombre] = useState('');
  const [conceptosData, setConceptosData] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [activate, setActivate] = useState(false);
  const [isViewMode, setIsViewMode] = useState(false);
  const [selectedConcepto, setSelectedConcepto] = useState(null);
  const [showCatalogo, setShowCatalogo] = useState(false);
  
  // Estados para mensajes
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: '',
    texto: '',
    icono: ''
  });
  const [mensajeConfirmacion, setMensajeConfirmacion] = useState({
    mostrar: false,
    titulo: '',
    texto: '',
    icono: ''
  });
  const [confirmAction, setConfirmAction] = useState(null);

  var op = require('../../../../modulos/datos');
  let token = localStorage.getItem('jwtToken');

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(conceptosData, headCells, filterFn);

  // Determinar si es modo consulta (operacion = 4)
  useEffect(() => {
    setIsViewMode(operacion === 4);
  }, [operacion]);

  // Cargar datos cuando se abre el modal con un ID
  useEffect(() => {
    if (show && id && id !== '') {
      cargarDatosGrupo();
    } else if (show && operacion === 1) {
      // Modo agregar - limpiar campos
      setCodGrupo('');
      setNombre('');
      setConceptosData([]);
    }
  }, [show, id, operacion]);

  const mostrarMensaje = (titulo, texto, icono) => {
    setMensaje({
      mostrar: true,
      titulo: titulo,
      texto: texto,
      icono: icono
    });
  };

  const ocultarMensaje = () => {
    setMensaje({
      mostrar: false,
      titulo: '',
      texto: '',
      icono: ''
    });
  };

  const mostrarConfirmacion = (titulo, texto, icono, onConfirm) => {
    setMensajeConfirmacion({
      mostrar: true,
      titulo: titulo,
      texto: texto,
      icono: icono
    });
    setConfirmAction(() => onConfirm);
  };

  const ocultarConfirmacion = () => {
    setMensajeConfirmacion({
      mostrar: false,
      titulo: '',
      texto: '',
      icono: ''
    });
    setConfirmAction(null);
  };

  const cargarDatosGrupo = () => {
    let codigoNomina = localStorage.getItem('codigonomina');
    codigoNomina = codigoNomina ? codigoNomina.replace(/"/g, '') : '';

    setActivate(true);
    const condi = `codgru='${id}'`;
    const endpointGrupo = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=*&nomtab=nomi${codigoNomina}.gruposnomina&condi=${condi}&orden=codgru`;

    axios.get(endpointGrupo, {
      headers: { "x-access-token": `${token}` }
    })
      .then(response => {
        if (response.status === 200 && response.data && response.data.length > 0) {
          const grupo = response.data[0];
          setCodGrupo(grupo.codgru.toString().padStart(2, '0'));
          setNombre(grupo.nomgru || '');

          // Cargar conceptos del grupo
          cargarConceptosGrupo();
        }
        setActivate(false);
      })
      .catch(error => {
        console.error('Error al cargar grupo:', error);
        mostrarMensaje('Error', 'Error al cargar los datos del grupo', 'error');
        setActivate(false);
      });
  };

  // Función para cargar conceptos del grupo
  const cargarConceptosGrupo = async () => {
    let codigoNomina = localStorage.getItem('codigonomina');
    codigoNomina = codigoNomina ? codigoNomina.replace(/"/g, '') : '';

    if (!id) {
      console.log('No hay ID de grupo para cargar conceptos');
      setConceptosData([]);
      return;
    }

    setActivate(true);

    try {
      // Usar el endpoint seleccionarConceptosPorGrupo que ya tienes
      const response = await axios.get(`${op.conexion}/api/nomina/seleccionarconceptosporgrupo`, {
        params: {
          esquema: `nomi${codigoNomina}`,
          codgru: id
        },
        headers: { "x-access-token": token }
      });

      console.log('Respuesta del endpoint seleccionarconceptosporgrupo:', response.data);

      if (response.data && response.data.success) {
        setConceptosData(response.data.data || []);
      } else if (Array.isArray(response.data)) {
        setConceptosData(response.data);
      } else {
        setConceptosData([]);
      }
    } catch (error) {
      console.error('Error al cargar conceptos:', error);
      mostrarMensaje('Error', 'Error al cargar los conceptos del grupo', 'error');
      setConceptosData([]);
    } finally {
      setActivate(false);
    }
  };

  // Función para abrir el modal de selección de conceptos
  const incluirConcepto = () => {
    setShowCatalogo(true);
  };

  // Función para manejar el concepto seleccionado desde el catálogo
  const handleConceptoSeleccionado = (concepto) => {
    if (concepto && concepto.codconcep) {
      // Verificar si ya existe en la lista
      const existe = conceptosData.some(c => c.codconcep === concepto.codconcep);

      if (!existe) {
        setConceptosData([...conceptosData, {
          codconcep: concepto.codconcep,
          nomconcep: concepto.nomconcep
        }]);
        mostrarMensaje('Éxito', 'Concepto agregado correctamente', 'exito');
      } else {
        mostrarMensaje('Aviso', 'El concepto ya está agregado al grupo', 'informacion');
      }
    }
    setShowCatalogo(false);
  };

  // Función para eliminar un concepto del grupo (solo localmente)
  const eliminarConcepto = () => {
    if (selectedConcepto !== null) {
      mostrarConfirmacion(
        'Confirmar Eliminación',
        '¿Está seguro de eliminar el concepto del grupo?',
        'confirmacion',
        () => {
          const nuevosConceptos = conceptosData.filter((_, index) => index !== selectedConcepto);
          setConceptosData(nuevosConceptos);
          setSelectedConcepto(null);
          mostrarMensaje('Éxito', 'Concepto eliminado correctamente', 'exito');
          ocultarConfirmacion();
        }
      );
    } else {
      mostrarMensaje('Aviso', 'Seleccione un concepto para eliminar', 'informacion');
    }
  };

  const salir = () => {
    setShow(false);
    if (setTabla) setTabla(0);
  };

  const handleAceptar = async () => {
    if (operacion === 4) {
      salir();
    } else {
      await guardarGrupo();
    }
  };

  // Función para guardar el grupo usando los endpoints
  const guardarGrupo = async () => {
    let codigoNomina = localStorage.getItem('codigonomina');
    codigoNomina = codigoNomina ? codigoNomina.replace(/"/g, '') : '';
    const esquema = `nomi${codigoNomina}`;

    setActivate(true);

    try {
      // 1. Primero guardar/actualizar el grupo
      const grupoResponse = await axios.post(`${op.conexion}/api/nomina/gruposnomina_act`, {
        operacion: operacion,  // 1=Insert, 2=Update, 3=Delete
        ccodgru: codGrupo,
        cnomgru: nombre.toUpperCase(),
        esquema1: esquema
      }, {
        headers: { "x-access-token": `${token}` }
      });

      console.log('Respuesta gruposnomina_act:', grupoResponse.data);

      if (grupoResponse.status !== 200) {
        throw new Error('Error al guardar el grupo');
      }

      // 2. Si es edición (operacion=2) o inclusión (operacion=1), manejar los conceptos
      if (operacion === 1 || operacion === 2) {

        // Primero, eliminar todos los conceptos existentes del grupo (solo para edición)
        if (operacion === 2) {
          const deleteResponse = await axios.post(`${op.conexion}/api/nomina/conceptosporgrupo_act`, {
            operacion: 3,  // operacion 3 = DELETE
            ccodgru: codGrupo,
            ccodconcep: '',  // Vacío para eliminar todos
            esquema: esquema
          }, {
            headers: { "x-access-token": `${token}` }
          });

          console.log('Eliminando conceptos existentes:', deleteResponse.data);
        }

        // Luego, insertar los nuevos conceptos uno por uno
        for (const concepto of conceptosData) {
          const insertResponse = await axios.post(`${op.conexion}/api/nomina/conceptosporgrupo_act`, {
            operacion: 2,  // operacion 2 = INSERT
            ccodgru: codGrupo,
            ccodconcep: concepto.codconcep,
            esquema: esquema
          }, {
            headers: { "x-access-token": `${token}` }
          });

          console.log(`Insertado concepto ${concepto.codconcep}:`, insertResponse.data);
        }
      }

      mostrarMensaje('Éxito', 'Proceso Exitoso', 'exito');
      setTimeout(() => {
        salir();
      }, 1500);

    } catch (error) {
      console.error('Error al guardar:', error);
      mostrarMensaje('Error', error.response?.data?.message || error.message || 'Error al guardar el grupo', 'error');
    } finally {
      setActivate(false);
    }
  };

  const handleCodigoChange = (e) => {
    let value = e.target.value;
    value = value.replace(/\D/g, '');
    if (value.length > 5) value = value.slice(0, 5);
    setCodGrupo(value);
  };

  const handleCodigoBlur = () => {
    if (codGrupo && codGrupo.length > 0) {
      setCodGrupo(codGrupo.padStart(5, '0'));
    }
  };

  const handleSearchConceptos = (e) => {
    let target = e.target;
    setFilterFn({
      fn: items => {
        const query = target.value.toLowerCase();
        if (query === "") return items;

        return items.filter(x =>
          (x.codconcep?.toString().toLowerCase().includes(query)) ||
          (x.nomconcep?.toLowerCase().includes(query))
        );
      }
    });
  };

  const handleRowClick = (index) => {
    setSelectedConcepto(index);
  };

  return (
    <>
      <Modal size="lg" show={show} centered backdrop="static" keyboard={false}>
        <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top">
          <h3 className="fw-bold m-0">
            {operacion === 1 && "Incluir Grupo de Nóminas"}
            {operacion === 2 && "Editar Grupo de Nóminas"}
            {operacion === 3 && "Eliminar Grupo de Nóminas"}
            {operacion === 4 && "Consultar Grupo de Nóminas"}
          </h3>
          <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
            Salir <i className="fa fa-times ms-2"></i>
          </a>
        </Modal.Header>
        <Modal.Body className="col-12 m-0 p-2">
				<ul className="nav d-flex mb-2 flex-wrap gap-1 align-items-center" id="ex-with-icons" role="tablist">
            <li className="nav-item" role="presentation">
              <button
               className="nav-link active bg-blue-100 text-light rounded h-100"
                id="datos-tab"
                data-bs-toggle="tab"
                data-bs-target="#datos-tab-pane"
                type="button"
                role="tab"
                aria-controls="datos-tab-pane"
                aria-selected="true"
              >
                Datos del Grupo
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
               className="nav-link bg-blue-200 text-light rounded h-100"
                id="conceptos-tab"
                data-bs-toggle="tab"
                data-bs-target="#conceptos-tab-pane"
                type="button"
                role="tab"
                aria-controls="conceptos-tab-pane"
                aria-selected="false"
              >
                Conceptos del Grupo ({conceptosData.length})
              </button>
            </li>
          </ul>
          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id="datos-tab-pane"
              role="tabpanel"
              aria-labelledby="datos-tab"
              tabIndex="0"
            >
              <form
                onSubmit={(e) => e.preventDefault()}
                className="col-12 m-0 p-0 d-flex flex-wrap"
              >
                <div className="col-4 m-0 p-0">
                  <Input
                    label="Cod. Grupo:"
                    value={codGrupo}
                    onChange={handleCodigoChange}
                    disabled={isViewMode || operacion === 2}
                    readOnly={isViewMode}
                  />
                </div>
                <div className="col-8 m-0 p-0 pl-2">
                  <Input
                    label="Nombre:"
                    value={nombre}
                    onChange={(e) => setNombre(e.target.value)}
                    disabled={isViewMode}
                    readOnly={isViewMode}
                    inputClassName='text-uppercase'
                  />
                </div>
              </form>
            </div>
            <div
              className="tab-pane fade"
              id="conceptos-tab-pane"
              role="tabpanel"
              aria-labelledby="conceptos-tab"
              tabIndex="0"
            >
              <div className="col-12 m-0 p-0 d-flex flex-wrap">
                <div className="col-11 m-0 p-0">
                  <div className="col-12 m-0 p-0 mb-2">
                    <Input
                      type="text"
                      onChange={handleSearchConceptos}
                      placeholder="Buscar concepto por código o nombre"
                      disabled={isViewMode && conceptosData.length === 0}
                    />
                  </div>

                  <TblContainer>
                    <TblHead />
                    <tbody>
                      {conceptosData.length > 0 ? (
                        recordsAfterPagingAndSorting().map((item, index) => (
                          <tr
                            key={index}
                            onClick={() => handleRowClick(index)}
                            style={{
                              cursor: 'pointer',
                              backgroundColor: selectedConcepto === index ? '#e3f2fd' : 'transparent'
                            }}
                          >
                            <td style={{ textAlign: "center" }}>{item.codconcep}</td>
                            <td style={{ textAlign: "left" }}>{item.nomconcep}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="2" style={{ textAlign: "center", padding: "20px" }}>
                            <i className="fas fa-inbox fa-2x mb-2"></i>
                            <p className="mb-0">No hay conceptos asociados a este grupo</p>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </TblContainer>
                  {conceptosData.length > 0 && <TblPagination />}
                </div>

                <div className="col-1 m-0 p-0 d-flex flex-column align-items-center justify-content-center gap-2">
                  {(operacion === 1 || operacion === 2) && !isViewMode && (
                    <>
                      <div className="col-auto m-0 p-0">
                        <button
                          className="btn btn-sm btn-success rounded-circle"
                          onClick={incluirConcepto}
                          title="Incluir Concepto"
                          style={{ width: '35px', height: '35px' }}
                        >
                          <i className="fas fa-plus"></i>
                        </button>
                      </div>

                      <div className="col-auto m-0 p-0">
                        <button
                          className="btn btn-sm btn-danger rounded-circle"
                          onClick={eliminarConcepto}
                          title="Eliminar Concepto"
                          style={{ width: '35px', height: '35px' }}
                        >
                          <i className="fas fa-trash-alt"></i>
                        </button>
                      </div>
                    </>
                  )}

                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <SuccessButton onClick={handleAceptar}>
            {operacion === 4 ? "Cerrar" : "Aceptar"}
          </SuccessButton>
          {operacion !== 4 && (
            <DangerButton onClick={salir}>Cancelar</DangerButton>
          )}
        </Modal.Footer>
        <Dimmer active={activate} inverted />
      </Modal>

      {/* Modal de catálogo de conceptos */}
      <CatalogoConceptosNomina
        show={showCatalogo}
        onHideCancelar={() => setShowCatalogo(false)}
        onHideAceptaCatalogo={handleConceptoSeleccionado}
      />

      {/* Componentes de mensajes */}
      <Mensaje
        mensaje={mensaje}
        onHide={ocultarMensaje}
      />

      <MensajeSiNo
        mensaje={mensajeConfirmacion}
        onHideSi={() => {
          if (confirmAction) confirmAction();
        }}
        onHideNo={ocultarConfirmacion}
      />
    </>
  );
}